import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

const enabledStages = ["production", "staging"];

if (JSON.parse(process.env.NEXT_PUBLIC_REPORT_DEV_ERRORS)) {
  enabledStages.push("development");
}

const BugsnagClient = Bugsnag.start({
  apiKey:
    process.env.BUGSNAG_SERVER_API_KEY ||
    process.env.NEXT_PUBLIC_BUGSNAG_BROWSER_API_KEY,

  appVersion: process.env.BUILD_ID,
  enabledReleaseStages: enabledStages,
  releaseStage: process.env.DEPLOY_ENV,
  plugins: [new BugsnagPluginReact(React)],
});

export default BugsnagClient;
